import { render, staticRenderFns } from "./Sud.vue?vue&type=template&id=643b67f6&scoped=true&lang=pug&"
import script from "./Sud.vue?vue&type=script&lang=js&"
export * from "./Sud.vue?vue&type=script&lang=js&"
import style0 from "./Sud.vue?vue&type=style&index=0&id=643b67f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b67f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
